import { createFileRoute, redirect } from "@tanstack/react-router";
import { Analytics } from "@/features/analytics";
import { isProductAdmin } from "@/lib/admin-allowlist";
import { supabase } from "@/lib/supabase";

export const Route = createFileRoute("/_authenticated/analytics/")({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      throw redirect({ to: "/sign-in" });
    }

    if (!isProductAdmin({ id: session.user.id, email: session.user.email })) {
      throw redirect({ to: "/403" });
    }
  },
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return <Analytics />;
}
